export default __webpack_public_path__ + "static/media/selectActiveCard.16d722d3.svg";